export const queryBuilder = (parameters) => {
  const queryString = Object.entries(parameters)
    .filter(
      ([_, value]) => value !== null && value !== undefined && value !== ""
    )
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  return queryString;
};
